import { Component } from "@angular/core";

import { Config } from "src/app/config";
import { ExamService } from "src/app/services/exam.service";
import { EditNameComponent } from "src/app/modals/editname/editname.component";
import { ModalDialogService } from "src/app/modals/modaldialog/modaldialog.service";
import { UploadButtonCompleteResponse } from "src/app/directives/uploadbutton.directive";
import { LibraryImage } from "src/app/models/libraryimage";
import { Exam } from "src/app/models/exam";

@Component({
  templateUrl: "./libraryimages.component.html",
  styleUrls: ["./libraryimages.component.scss"],
})
export class LibraryImagesComponent {
  exam: Exam;
  uploadUrl: string;
  uploadFolder: string;
  uploadingImage: boolean;
  uploadingProgress: number;

  constructor(private modalDialogService: ModalDialogService, private examService: ExamService) {
    this.exam = this.examService.currentExam;
    this.uploadUrl = Config.SERVER_API_UPLOAD;
    this.uploadFolder = Config.SERVER_UPLOADFOLDER;
    this.uploadingImage = false;
  }

  onUploadProgress(progress: number): void {
    this.uploadingImage = true;
    this.uploadingProgress = progress;
  }
  onUploadComplete(data: UploadButtonCompleteResponse): void {
    let image = new LibraryImage();

    let count = 0;
    let found: boolean;
    do {
      found = false;
      image.name = data.filename + (count == 0 ? "" : "_" + count);
      if (this.exam.library.checkImageNameInUse(image.name)) {
        found = true;
      }
    } while (found);

    image.source = data.filename;
    this.exam.library.images.push(image);
    this.uploadingImage = false;
  }
  onUploadError(msg: string): void {
    this.modalDialogService.showAlert(Config.APP_NAME, msg);
    this.uploadingImage = false;
  }

  onEditImage(image: LibraryImage): void {
    const modal = this.modalDialogService.createModal();
    modal.setTitle("Image name");
    modal.setButtonCancelOk();
    const component = modal.setBodyComponent(EditNameComponent);
    component.createFormWithValues(image.name);
    component.onFormStatusChanges.subscribe(invalid => {
      modal.buttons[1].disabled = invalid;
    });
    modal.show().subscribe(
      button => {
        if (button.index == 0) {
          modal.close();
        } else if (button.index == 1) {
          if (component.hasErrors()) {
            return;
          }
          const formValues = component.values;
          formValues.name = formValues.name.trim();
          if (this.exam.library.checkImageNameInUse(formValues.name, image)) {
            this.modalDialogService.showAlert(Config.APP_NAME, "The name is already in use");
            return;
          }
          image.name = formValues.name;
          modal.close();
        }
      },
      error => {},
      () => {
        this.modalDialogService.dismissModal(modal);
      },
    );
  }

  onDeleteImage(image: LibraryImage): void {
    let index = this.exam.library.images.indexOf(image);
    if (index >= 0) {
      this.modalDialogService.showConfirmation(Config.APP_NAME, "Are you sure to delete the image?", () => {
        // Yes
        this.exam.library.images.splice(index, 1);
      });
    }
  }
}
